export default __webpack_public_path__ + "_/videos/lootbox/video-dota-abb4698781cd4be023e941662fdef4a5135bda151aadafe044e6997a699a9f5e.ogv";